import styled from "styled-components";
import { colors, spacing, typography } from "../../../../../../styles/theme";

export const PrescribedQuantityContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PrescribedQuantityCircleWrapper = styled.div`
  transform: scale(1.25);
`;

export const PrescribedQuantityCircleContent = styled.div`
  position: relative;
  display: flex;
  height: 28px;
  width: 28px;
  align-items: center;
  justify-content: center;
`;

export const PrescribedQuantitySvg = styled.svg`
  height: 28px;
  width: 28px;
`;

export const PrescribedQuantityText = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: ${typography("weights.bold")};
  color: ${colors("neutral")};
`;

export const PrescribedQuantityUnit = styled.span`
  font-size: ${typography("caption2.fontSize")};
  color: ${colors("neutral.base")};
  margin-top: ${spacing("extraSmall")};
`;

export const DispensedQuantityContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

export const DispensedQuantityCircleWrapper = styled.div`
  transform: scale(1.25);
`;

export const DispensedQuantityCircleContent = styled.div`
  position: relative;
  display: flex;
  height: 28px;
  width: 28px;
  align-items: center;
  justify-content: center;
`;

export const DispensedQuantitySvg = styled.svg`
  height: 28px;
  width: 28px;
`;

export const DispensedQuantityText = styled.span`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: ${typography("weights.bold")};
  color: ${colors("neutral")};
`;

export const DispensedQuantityUnit = styled.span`
  font-size: ${typography("caption2.fontSize")};
  color: ${colors("neutral.base")};
  margin-top: ${spacing("extraSmall")};
`;

export const DispensedQuantityLeftAmount = styled.span`
  font-size: ${typography("caption2.fontSize")};
  color: #D97706;
  font-weight: ${typography("weights.bold")};
`;

export const DispensedQuantityRowWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing("1")};
`;

export const CheckIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: #059669;
  font-size: 10px;
  font-weight: bold;
`;